import React from "react";
import CardBeneficios from "./CardBeneficios";

const BeneficiosSection = ({ productos }) => {
  return (
    <section
      className="mt-[70px] md:mt-[100px] lg:mt[90px] mb-[70px] md:mb-[100px] lg:mb-[90px] px-2 md:px-0 lg:px-0 flex bg-sidom-blue flex-col w-full"
      aria-labelledby="beneficios"
    >
      <h1
        id="beneficios"
        className="text-sidom-orange container text-3xl md:text-[40px] lg:text-[45px] leading-tight mt-[70px] md:mt-[100px] lg:mt[90px] font-extrabold text-left mb-[60px]"
      >
        Beneficios
      </h1>

      {/* Lista de cards con beneficios */}
      <div className="mb-[70px] md:mb-[100px] lg:mb-[90px] px-2 md:px-0 lg:px-0">
        {productos.map((producto, index) => (
          <CardBeneficios
            key={index}
            titulo={producto.title}
            descripcion={producto.description}
            backgroundColor="bg-sidom-blue"
            textcolor="text-sidom-light"
          />
        ))}
      </div>

      {/* Separador visual */}
      <div className="container flex justify-center items-center">
        <div className="container dark:border-b-[1px] dark:border-white"></div>
      </div>
    </section>
  );
};

export default BeneficiosSection;
